import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchExternalMediaLogs = async ({ page, patientId, trialId, mediaType }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  params.append("page", page);
  params.append("patient_id", patientId);
  params.append("trial_id", trialId);

  if (mediaType) {
    params.append("media_type", mediaType);
  }

  const response = await axios.get(
    `${__API_URL__}/api/photos/get_external_media_logs/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useGetExternalMediaLogs = ({ page = 1, patientId, trialId, mediaType, enabled = true }) => {
  return useQuery({
    queryKey: ["external_media_logs", page, patientId, trialId, mediaType],
    queryFn: () =>
      fetchExternalMediaLogs({
        page,
        patientId,
        trialId,
        mediaType,
      }),
    enabled: enabled && Boolean(patientId && trialId),
    keepPreviousData: true,
  });
};

export default useGetExternalMediaLogs;
